import { render } from "./LogoBlock.vue?vue&type=template&id=1d126e01&scoped=true&ts=true"
import script from "./LogoBlock.vue?vue&type=script&lang=ts"
export * from "./LogoBlock.vue?vue&type=script&lang=ts"

import "./LogoBlock.vue?vue&type=style&index=0&id=1d126e01&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d126e01"]])

export default __exports__